import React from "react";
import { Callout, Intent } from "@blasterjs/core";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import ImageViewer from "../components/ImageViewer";
import InfoSidebarImage from "../components/InfoSidebarImage";
import TopBarImage from "../components/TopBarImage";
import Content from "../components/Content";
import { useAppDispatch, useAppSelector } from "../hooks";
import { imageFetch, resetImage } from "../slices/caseImageViewer";
import { studyFetchRequest } from "../slices/studyConfiguration";
import { RolePermissions } from "../permissions";
import { queryDetailsFetchByImage, setCurrentViewQueryObjectType } from "../slices/queryDetails";
import { QueryObjectType } from "../models";

const Image = () => {
  const params = useParams();
  const imageId = params.id || "no-id";
  const studyId = params.studyId || "no-study-id";

  const dispatch = useAppDispatch();

  const imageWithAnnotations = useAppSelector(state => state.caseImageViewer.imageWithAnnotations);
  const config = useAppSelector(state => state.config);
  const loggedInUser = useAppSelector(state => state.auth.loggedInUser);
  const queryDetailsResource = useAppSelector(state => state.queryDetails);
  const queryDetails =
    "resource" in queryDetailsResource.queryDetails
      ? queryDetailsResource.queryDetails.resource
      : [];

  const study =
    imageWithAnnotations &&
    "resource" in imageWithAnnotations &&
    imageWithAnnotations.resource &&
    imageWithAnnotations.resource.study
      ? imageWithAnnotations.resource.study
      : null;
  const studyName = study && study.name ? study.name : null;

  useEffect(() => {
    dispatch(imageFetch(imageId));
    dispatch(studyFetchRequest(studyId));
    dispatch(
      setCurrentViewQueryObjectType({
        queryViewObjectType: QueryObjectType.Image,
        viewObjectId: imageId
      })
    );
    dispatch(queryDetailsFetchByImage(imageId));
    return () => {
      dispatch(resetImage());
    };
  }, [imageId, studyId]);

  const errorText =
    "errorMessage" in config.config
      ? config.config.errorMessage
      : imageWithAnnotations && "errorMessage" in imageWithAnnotations
      ? imageWithAnnotations.errorMessage
      : null;
  const content =
    "resource" in config.config &&
    (imageWithAnnotations === null || "resource" in imageWithAnnotations) &&
    "resource" in loggedInUser &&
    loggedInUser.resource.can([RolePermissions.AP_ImageViewer_ViewimageViewer]) ? (
      <ImageViewer
        imageWithAnnotations={imageWithAnnotations === null ? null : imageWithAnnotations.resource}
        tileServerLocation={config.config.resource.tileServerLocation}
        topBar={
          <TopBarImage
            image={
              imageWithAnnotations === null
                ? null
                : imageWithAnnotations.resource.imageAndQuery.image
            }
          />
        }
        sidebar={
          imageWithAnnotations === null ? null : (
            <InfoSidebarImage
              studyName={studyName}
              queryDetails={queryDetails}
              imageWithAnnotations={imageWithAnnotations.resource}
              loggedInUser={loggedInUser.resource}
              dispatch={dispatch}
            />
          )
        }
      />
    ) : errorText ? (
      <Callout intent={Intent.DANGER}>{errorText}</Callout>
    ) : null;
  return (
    <Content
      isLoading={
        imageWithAnnotations === null ||
        "isPending" in imageWithAnnotations ||
        "isPending" in config
      }
    >
      {content}
    </Content>
  );
};

export default Image;
